<template>
<div class="chapter">
<div class="inner_page">
<div class="pppc"><i>Recent Titles by Marjorie Eccles</i></div>
<div class="pc"><span class="sc">THE SHAPE OF SAND</span></div>
<div class="pc"><span class="sc">SHADOWS AND LIES</span></div>
<div class="pc"><span class="sc">LAST NOCTURNE</span></div>
<div class="pc"><span class="sc">BROKEN MUSIC</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also_by.vue?2f69e8cb